function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M48 33V17.4L38.8 4.8L24 0L9.2 4.8L0 17.4V33L9.2 45.7L24 50.5L38.8 45.7L48 33Z",
  fill: "url(#paint0_radial)"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M44.9 13.2L41.9 9L26.6 16.7H21.4L6.1 9L3 13.2L15.7 25.2L3 37.2L6.1 41.4L21.4 33.7H26.6L41.9 41.4L45 37.2L32.3 25.2L44.9 13.2Z",
  fill: "black"
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  d: "M48 17.4L44.9 13.2L32.8 22L28.4 18.8L41.9 9L38.8 4.8L26.6 13.7V0.8L24 0L21.4 0.8V13.7L9.2 4.8L6.1 9L19.6 18.8L15.2 22L3.1 13.2L0 17.4L10.7 25.2L0 33L3.1 37.2L15.2 28.4L19.6 31.6L6.1 41.4L9.2 45.6L21.4 36.7V49.6L24 50.4L26.6 49.6V36.8L38.8 45.7L41.9 41.5L28.4 31.7L32.8 28.5L44.9 37.3L48 33L37.3 25.2L48 17.4ZM24 28.4L19.6 25.2L24 22L28.4 25.2L24 28.4Z",
  fill: "white"
});

var _ref5 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("radialGradient", {
  id: "paint0_radial",
  cx: 0,
  cy: 0,
  r: 1,
  gradientUnits: "userSpaceOnUse",
  gradientTransform: "translate(24.0001 25.2351) scale(24.6253)"
}, /*#__PURE__*/React.createElement("stop", {
  offset: 0.6667
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "white"
})));

var SvgIsologo = function SvgIsologo(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 51,
    viewBox: "0 0 48 51",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3, _ref4, _ref5);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgIsologo, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/isologo.8692b03d.svg";
export { ForwardRef as ReactComponent };